<template>
  <div>
    <div class="alert alert-block alert-info fade in">
      <span>
        <i class="fa fa-info-circle"></i> Pour changer de date, les changements apportés doivent être sauvegardés ou annulés.
      </span>
    </div>
    <div v-for="(box, index) in boxes" v-bind:key="index">
      <sales-grid-customer-box
        :default-customer-id="box.customer_id"
        :default-date="box.selected_date"
        :date-picker-placeholder="datePickerPlaceholder"
        :date-picker-placeholder-format="datePickerPlaceholderFormat"
        ref="box"
        @change="onChange">
      </sales-grid-customer-box>
    </div>
  </div>
</template>

<script>
export default {
  name: "sales-grid",
  props: {
    defaultDate: {
      type: String,
      required: true,
    },
    customerIds: {
      type: Array,
      default: function () {
        return [];
      },
    },
    datePickerPlaceholder: {
      type: String,
      required: true,
    },
    datePickerPlaceholderFormat: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedDate: this.defaultDate,
      boxes: [],
    };
  },
  mounted() {
    for (const customer_id of this.customerIds) {
      this.addBox(customer_id, this.defaultDate);
    }
  },
  methods: {
    addBox(customer_id, date) {
      this.boxes.push({
        customer_id: customer_id,
        selected_date: date,
      });
    },
    onChange() {
      let boxes = this.$refs["box"];
      for (const box of boxes) {
        if(box.$data.hasChanges){
          window.toggleWarn(true);
          return;
        }
      }
      window.toggleWarn(false)
    }
  },
};
</script>

<style lang="scss" scoped>
</style>